import React, { useEffect, useState } from "react";
import { getTestimonialsService } from "../services/apiService";
import { withImageVersion } from "../contextApi/ImageVersionContext";

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const response = await getTestimonialsService();

      if (response?.status) {
        setTestimonials(response.data || []);
      }
    } catch (error) {
      console.error("Failed to fetch testimonials:", error);
    }
  };

  return (
    <>
      <style>{`
        @keyframes scrollLeft {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}</style>
      <section
        style={{
          padding: "70px 0",
          background: "linear-gradient(#eef8ff,#dff4ff)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            maxWidth: "1400px",
            margin: "0 auto",
            padding: "0 20px",
          }}
        >
          <h1
            style={{
              textAlign: "center",
              fontSize: "48px",
              fontWeight: "800",
              color: "#17233b",
              lineHeight: "1.3",
            }}
          >
            From Small Shops to Growing Brands — We Support Every Sale
          </h1>

          <p
            style={{
              textAlign: "center",
              color: "#5b6779",
              margin: "25px 0 50px",
              fontSize: "18px",
            }}
          >
            See what our customers have to say about their experience
          </p>

          <div
            style={{
              overflow: "hidden",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                width: "max-content",
                animation: "scrollLeft 100s linear infinite",
              }}
            >
              {[...testimonials, ...testimonials].map((item, index) => (
                <div
                  key={`${item.id}-${index}`}
                  style={{
                    width: "340px",
                    background: "#fff",
                    borderRadius: "18px",
                    padding: "24px",
                    margin: "0 14px",
                    boxShadow: "0 10px 30px rgba(0,120,255,.12)",
                    flexShrink: 0,
                  }}
                >
                  <div
                    style={{
                      color: "#ffb400",
                      fontSize: "22px",
                      marginBottom: "20px",
                    }}
                  >
                    ★★★★★
                  </div>

                  <p
                    style={{
                      color: "#46566d",
                      lineHeight: "1.8",
                      minHeight: "130px",
                    }}
                  >
                    {item.cust_msg}
                  </p>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "14px",
                      borderTop: "1px solid #eee",
                      paddingTop: "5px",
                    }}
                  >
                    <img
                      src={withImageVersion(item.photo)}
                      alt={item.name}
                      style={{
                        width: "54px",
                        height: "54px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />

                    <div>
                      <h4
                        style={{
                          margin: 0,
                          color: "#17233b",
                        }}
                      >
                        {item.name}
                      </h4>

                      <span
                        style={{
                          color: "#6b7280",
                          fontSize: "14px",
                        }}
                      >
                        {item.designation}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Testimonials;
